import { styled } from "@mui/material/styles";

export const PageTitleContainer = styled("div")(({ theme }) => ({
  "& h1": {
    fontWeight: "bold",
    fontSize: "clamp(1rem, 1rem + 2vw, 2rem)",
    margin: "0px 0 20px 0",
    lineHeight: "1.1",
    // [theme.breakpoints.up("md")]: {
    //   margin: "20px 0 20px 0",
    // },
    "& span": {
      display: "block",
      fontSize: "16px",
      fontWeight: "normal",
      opacity: ".8",
      marginTop: "10px",
      lineHeight: "1.4"
    }
  },
  "& h2": {
    fontWeight: "bold",
    fontSize: "clamp(0.75rem, 0.75rem + 2vw, 1.3rem)",
    margin: "0px 0 8px 0",
    lineHeight: "1.2",
  },
}));
